import { Close, Delete, WidgetExpand, WidgetSettings } from "assets/icons/Common";
import classNames from "classnames";
import React from "react";
import styled from "styled-components";
import { ButtonProps } from "types/ButtonProps";

import { IconButton } from "./primitives";

export const PreventDragClass: string = "no-drag";
export const WidgetControlClass: string = "widget-control";
export const MODAL_INDEX = 7000; // $zindex-modal from bootstrap;

const CloseHandle: React.FC<ButtonProps> = ({ ...props }) => {
  return <IconButton Icon={Close} {...props} />;
};

const RemoveHandle: React.FC<ButtonProps> = ({ ...props }) => {
  return <IconButton Icon={Delete} accentColor="var(--danger)" {...props} />;
};

const SettingsHandle: React.FC<ButtonProps> = ({ ...props }) => {
  return <IconButton Icon={WidgetSettings} {...props} />;
};

// Due to the way React-Resizable works, we export this so we can use ForwardRef
export const WidgetResizeHandle = React.forwardRef<HTMLButtonElement, { handleAxis: string }>(
  (props, ref) => {
    const { handleAxis, ...rest } = props;
    return (
      <ResizeHandle Icon={WidgetExpand} ref={ref} className={`handle-${handleAxis}`} {...rest} />
    );
  },
);

export const WidgetCloseSpotlight = styled(CloseHandle).attrs({
  className: classNames(PreventDragClass, "spotlight-control"),
})`
  position: absolute;
  width: var(--widget-handle-size);
  height: var(--widget-handle-size);
  left: calc(var(--widget-handle-size) / -2);
  top: calc(var(--widget-handle-size) / -2);
  z-index: ${MODAL_INDEX + 1};
`;

export const WidgetRemoveHandle = styled(RemoveHandle).attrs({
  className: classNames(PreventDragClass, WidgetControlClass), // Should be imported from Widget.tsx. Currently doesn't work
})`
  position: absolute;
  width: var(--widget-handle-size);
  height: var(--widget-handle-size);
  left: calc(var(--widget-handle-size) / -2);
  top: calc(var(--widget-handle-size) / -2);
  z-index: ${MODAL_INDEX + 1};
`;

export const WidgetSettingsHandle = styled(SettingsHandle).attrs({
  className: classNames(PreventDragClass, WidgetControlClass),
})`
  position: absolute;
  width: var(--widget-handle-size);
  height: var(--widget-handle-size);
  right: calc(var(--widget-handle-size) / -2 + (var(--widget-handle-size) * 1.5));
  top: calc(var(--widget-handle-size) / -2);
  z-index: ${MODAL_INDEX + 1};
`;

const ResizeHandle = styled(IconButton).attrs({
  className: classNames(PreventDragClass, WidgetControlClass),
})`
  position: absolute;
  width: var(--widget-handle-size);
  height: var(--widget-handle-size);
  right: calc(var(--widget-handle-size) / -2);
  bottom: calc(var(--widget-handle-size) / -2);
  cursor: nwse-resize !important;
  padding: 7px;
  z-index: ${MODAL_INDEX + 1};
`;
